import {FunctionComponent} from 'react'
import ReactDOM from 'react-dom'
import {
  Wrapper,
  Header,
  StyledModal,
  HeaderText,
  CloseButton,
  Content,
  Backdrop,
} from './modal.style'

export interface ModalProps {
  isShown: boolean
  hide: () => void
  modalContent: JSX.Element
  headerText: string
}

export const Modal: FunctionComponent<ModalProps> = ({isShown, hide, modalContent, headerText}) => {
  const modal = (
    <>
      <Backdrop />
      <Wrapper>
        <StyledModal>
          <Header>
            <HeaderText>
              <h3 className='fw-bolder m-0'>
                <i className='fs-3 text-primary'></i> {headerText}
              </h3>
            </HeaderText>
            <CloseButton className='btn btn-sm btn-icon fw-bolder' onClick={hide}>
              <i className='text-danger fas fa-times fa-2x fw-bolder'></i>
            </CloseButton>
          </Header>

          <Content>
            <div className='modal-body-wrapper'>
              {modalContent}
              <div className='d-flex justify-content-end'>
                <button className='btn btn-danger btn-sm fw-bold' onClick={hide}>
                  <span className='fa fa-times'></span>
                </button>
              </div>
            </div>
          </Content>
        </StyledModal>
      </Wrapper>
    </>
  )

  return isShown ? ReactDOM.createPortal(modal, document.body) : null
}
